export default __webpack_public_path__ + "oley-logo-blue.png";